import ChatHistoryList from "./ChatHistoryList";

import "./ChatHistoryStyles.css";
import LoadingSection from "./LoadingSection";
import { Conversation, Conversations, HttpErrorType } from "../types";
import { ErrorMessage } from "./ErrorMessage";

type ChatHistoryProps = {
  onItemClick: (conversation: Conversation) => void;
  onItemDelete: (conversation: Conversation) => void;
  activeConversationId: string | null;
  isLoadingChatConversations: boolean;
  errorLoadingChatConversations: HttpErrorType | null;
  chatConversations: Conversations | null;
};

export const ChatHistory = ({
  onItemClick,
  onItemDelete,
  activeConversationId,
  isLoadingChatConversations,
  errorLoadingChatConversations,
  chatConversations,
}: ChatHistoryProps) => {
  return (
    <div className="chat-history-container" data-testid="chat-history-container">
      {isLoadingChatConversations && <LoadingSection />}
      {chatConversations && (
        <ChatHistoryList
          conversations={chatConversations}
          activeConversationId={activeConversationId}
          onItemCLick={onItemClick}
          onItemDelete={onItemDelete}
        />
      )}
      {errorLoadingChatConversations && <ErrorMessage errorMessage={errorLoadingChatConversations?.message} />}
    </div>
  );
};
